import { Outlet } from "react-router-dom";

/**
 * Public, chrome-less layout for /login and similar.
 * The pages render their own full-page UI; we just provide an outlet.
 */
export function AuthLayout() {
  return <Outlet />;
}
